import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BGImg from "../Assests/Images/2001.jpg";

export default function PatientLogin() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <div
            className="min-vh-100 d-flex align-items-center justify-content-center position-relative"
            style={{
                backgroundImage: `linear-gradient(rgba(5, 17, 35, 0.62), rgba(5, 17, 35, 0.72)), url(${BGImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="container px-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">
                        <div
                            className="card border-0 shadow-lg rounded-4 overflow-hidden"
                            style={{ background: "rgba(255,255,255,0.88)", backdropFilter: "blur(10px)" }}
                        >
                            <div className="card-body p-4 p-md-5">
                                <div className="text-center mb-5">
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light-primary text-primary mb-3"
                                         style={{ width: "64px", height: "64px" }}>
                                        <i className="bi bi-shield-lock-fill fs-2"></i>
                                    </div>
                                    <h2 className="fw-bold text-dark mb-2">Patient Login</h2>
                                    <div className="text-muted">Sign in to continue to your portal</div>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-4">
                                        <label className="form-label fw-semibold text-dark">
                                            Email Address
                                        </label>
                                        <div className="input-group input-group-solid">
                                            <span className="input-group-text bg-white border-end-0">
                                                <i className="bi bi-envelope text-primary"></i>
                                            </span>
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control form-control-lg border-start-0"
                                                placeholder="Enter email"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-semibold text-dark">
                                            Password
                                        </label>
                                        <div className="input-group input-group-solid">
                                            <span className="input-group-text bg-white border-end-0">
                                                <i className="bi bi-lock text-primary"></i>
                                            </span>
                                            <input
                                                type="password"
                                                name="password"
                                                className="form-control form-control-lg border-start-0"
                                                placeholder="Enter password"
                                                value={formData.password}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100 btn-lg fw-bold mb-3"
                                        onClick={() => navigate("/request-appointment")}
                                    >
                                        <i className="bi bi-box-arrow-in-right me-2"></i>
                                        Login
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-light-primary w-100 btn-lg fw-semibold"
                                        onClick={() => navigate(-1)}
                                    >
                                        <i className="bi bi-arrow-left me-2"></i>
                                        Back
                                    </button>
                                </form>

                                <div className="text-center mt-4 text-muted fs-7">
                                    Secure access for existing patients
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
